import { buildPersonalSignalContext } from './personalSignalContext';
import { evaluatePersonalSignals, flattenPersonalSignals } from './personalSignalRegistry';
import type { PersonalDashboardDTO, PersonalDashboardFacts } from './reportsPersonalTypes';

export function buildPersonalDashboardDTO(
  facts: PersonalDashboardFacts,
  source: 'server' | 'device'
): PersonalDashboardDTO {
  const ctx = buildPersonalSignalContext(facts);
  const { branchSignals, operatorSignals } = evaluatePersonalSignals(facts, ctx);
  return {
    facts,
    branchSignals,
    operatorSignals,
    activeOperatorCount: ctx.activeOperatorCount,
    teamMode: ctx.teamMode,
    source,
  };
}

export function countActivePersonalSignals(dto: PersonalDashboardDTO): number {
  return flattenPersonalSignals(dto.branchSignals, dto.operatorSignals).length;
}

export function signalsForOperator(
  dto: PersonalDashboardDTO,
  cashierUserId: string | null
): import('./reportsPersonalTypes').PersonalSignal[] {
  const key = cashierUserId ?? '__no_cashier__';
  return [...dto.branchSignals.filter((s) => s.operatorUserId == null), ...(dto.operatorSignals.get(key) ?? [])];
}
